// Mock data for Winnex Pro Services

export const mockData = {
  // Navigation items
  navigation: {
    solutions: [
      { name: 'Game Aggregation', href: '/solutions/game-aggregation', description: 'Multi-studio catalog with unified API' },
      { name: 'Esports Feeds', href: '/solutions/esports-feeds', description: 'Live odds and data with low latency' },
      { name: 'Gamification', href: '/solutions/gamification', description: 'Points, missions, tournaments & rewards' },
      { name: 'Localization', href: '/solutions/localization', description: 'Multi-language support and regional formats' }
    ],
    mainNav: [
      { name: 'Pricing', href: '/pricing' },
      { name: 'Docs', href: '/docs' },
      { name: 'Case Studies', href: '/case-studies' },
      { name: 'Compliance', href: '/compliance' },
      { name: 'Blog', href: '/blog' },
      { name: 'Contact', href: '/contact' }
    ]
  },

  // Hero section data
  hero: {
    title: 'The engagement layer for iGaming & esports',
    subtitle: 'Games, live data, rewards, and localization in one API.',
    description: 'Integrate in days. Scale globally. Stay compliant.',
    primaryCTA: 'Book a Demo',
    secondaryCTA: 'Start Free Sandbox',
    trustBadges: {
      studios: '200+',
      uptime: '99.99%',
      operators: '150+'
    }
  },

  // 4 Pillars data
  pillars: [
    {
      id: 'game-aggregation',
      title: 'Game Aggregation',
      description: 'Access a unified catalog of games from multiple studios with comprehensive metadata, RTP data, and jurisdiction filtering.',
      features: [
        'Multi-studio catalog management',
        'Unified API integration',
        'Real-time release updates',
        'Jurisdiction compliance filters'
      ],
      icon: 'gamepad-2'
    },
    {
      id: 'esports-feeds',
      title: 'Esports Feeds',
      description: 'Real-time esports data with ultra-low latency, comprehensive coverage, and reliable settlement for all major titles.',
      features: [
        'Live odds & data feeds',
        'Multi-title coverage',
        'Sub-second latency',
        'Automated settlement'
      ],
      icon: 'trophy'
    },
    {
      id: 'gamification',
      title: 'Gamification',
      description: 'Boost player engagement with points, missions, tournaments, and rewards while maintaining responsible gaming standards.',
      features: [
        'Points & tier systems',
        'Mission campaigns',
        'Tournament brackets',
        'Anti-fraud protection'
      ],
      icon: 'star'
    },
    {
      id: 'localization',
      title: 'Localization',
      description: 'Seamlessly adapt your platform for global markets with multi-language support and regional formatting.',
      features: [
        'Multi-language strings',
        'Regional odds formats',
        'Cultural adaptations',
        'Real-time translation'
      ],
      icon: 'globe'
    }
  ],

  // Stats data
  stats: {
    gamesIntegrated: '50,000+',
    eventsPerMonth: '2M+',
    averageLatency: '<50ms',
    languages: '40+'
  },

  // Partner logos (placeholder)
  partners: [
    { name: 'Studio Alpha', logo: 'https://via.placeholder.com/120x60/f8f9fa/6c757d?text=Studio+A' },
    { name: 'Gaming Corp', logo: 'https://via.placeholder.com/120x60/f8f9fa/6c757d?text=Gaming+Corp' },
    { name: 'Esports Pro', logo: 'https://via.placeholder.com/120x60/f8f9fa/6c757d?text=Esports+Pro' },
    { name: 'Global Games', logo: 'https://via.placeholder.com/120x60/f8f9fa/6c757d?text=Global+Games' },
    { name: 'Live Sports', logo: 'https://via.placeholder.com/120x60/f8f9fa/6c757d?text=Live+Sports' },
    { name: 'Tech Solutions', logo: 'https://via.placeholder.com/120x60/f8f9fa/6c757d?text=Tech+Sol' }
  ],

  // Compliance features
  compliance: {
    title: 'Enterprise-Grade Security & Compliance',
    features: [
      { title: 'SOC 2 Type II', description: 'Certified security controls and data protection' },
      { title: 'GDPR Compliant', description: 'Full data processing agreement and privacy controls' },
      { title: 'RNG Provenance', description: 'Verifiable random number generation for fair play' },
      { title: 'KYC Integration', description: 'Seamless partner verification and onboarding' }
    ]
  },

  // Developer section
  developer: {
    title: 'Built for Developers',
    description: 'Comprehensive SDKs, detailed documentation, and sandbox environment to get you up and running quickly.',
    sdks: [
      { name: 'REST API', description: 'RESTful endpoints with OpenAPI specification' },
      { name: 'WebSocket', description: 'Real-time data streaming for live events' },
      { name: 'Webhooks', description: 'Event-driven notifications with retry logic' },
      { name: 'SDKs', description: 'Native libraries for Node.js, Python, Go, and PHP' }
    ]
  },

  // Footer data
  footer: {
    company: 'Winnex Pro Services',
    description: 'The engagement layer for iGaming & esports platforms.',
    legal: [
      { name: 'Terms of Service', href: '/terms' },
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Data Processing Agreement', href: '/dpa' },
      { name: 'Cookie Policy', href: '/cookies' }
    ],
    support: [
      { name: 'Documentation', href: '/docs' },
      { name: 'API Status', href: '/status' },
      { name: 'Support Center', href: '/support' },
      { name: 'Contact Us', href: '/contact' }
    ],
    company_links: [
      { name: 'About Us', href: '/about' },
      { name: 'Careers', href: '/careers' },
      { name: 'Press Kit', href: '/press' },
      { name: 'Partners', href: '/partners' }
    ]
  }
};